<script setup lang="ts">

interface Props{
  icon?: string;
  header: string;
  subheader: string;
}

const props = withDefaults(defineProps<Props>(), {
  icon: 'fa-fw fa-light fa-magnifying-glass'
});

</script>

<template>
  <div class="container">
    <IonText class="centered-text ion-padding">
      <div class="icon-container">
        <i
          class="big-icon"
          :class="icon"
        />
      </div>
      <p class="message-header">
        {{ header }}
      </p>
      <p class="message-text">
        {{ subheader }}
      </p>
    </IonText>
  </div>
</template>

<style scoped>

.container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
}
.centered-text {
    display: flex;
    align-items: center;
    flex-direction: column;
}

.message-header {
    font-size: 18px;
    font-weight: 600;
    line-height: 125%;
    text-align: center;
}

.message-text {
    font-size: 16px;
    line-height: 125%;
    color: var(--ion-color-step-600);
    text-align: center;
    padding: 0;
    margin: 0;
    text-wrap: balance;
}

.big-icon {
    font-size: 40px;
}

.icon-container {
    align-items: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    background: var(--ion-card-background);
    border-radius: 100px;
    width: 94px;
    height: 94px;
    color: var(--ion-color-primary);
}

</style>
